import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/category.css";
import "../styles/cartpop.css";
import { ProductApi } from "../api/product.api";
import ProductListDisplay from "../components/weddigservice/ProductListDisplay";
import { CategoryApi } from "api/category.api";

function CategoryProductListPage() {
  const { displayCategoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [displayCategory, setDisplayCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (isInitialLoad) {
      window.scrollTo(0, 0);
      setIsInitialLoad(false);
    }
  }, [isInitialLoad]);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const productListResponse =
        await ProductApi.getProductsByDisplayCategoryId(displayCategoryId);
      setProducts(productListResponse.products);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  }, [displayCategoryId]);

  const fetchDisplayCategory = useCallback(async () => {
    try {
      const response = await CategoryApi.getDisplayCategoryById(
        displayCategoryId
      );
      setDisplayCategory(response);
    } catch (error) {
      console.error("Error fetching display category:", error);
    }
  }, [displayCategoryId]);

  // Fetch category products
  useEffect(() => {
    fetchProducts();
    fetchDisplayCategory();
  }, [fetchDisplayCategory, fetchProducts]);

  return (
    <> 
      <ProductListDisplay
        products={products}
        displayName={displayCategory?.name}
        isLoading={loading}
      />
    </>
  );
}

export default CategoryProductListPage;